import { render, staticRenderFns } from "./dailyrecord.vue?vue&type=template&id=78676d9b&scoped=true&"
import script from "./dailyrecord.vue?vue&type=script&lang=js&"
export * from "./dailyrecord.vue?vue&type=script&lang=js&"
import style0 from "./dailyrecord.vue?vue&type=style&index=0&id=78676d9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78676d9b",
  null
  
)

export default component.exports